export const createGalleryApi = (fetchApi) => {

  function getActiveImages() {
    return fetchApi(`/gallery/active`, 'GET');
  }

  return {
    getActiveImages
  };
};